import React, { useEffect } from 'react';
import FormGroup from "../FormGroup";
import PropTypes from "prop-types";
import { useI18n } from 'utils/I18n/context';

const ConversionUserInfoChart = ({ item, loading, init }) => {
    const { t } = useI18n();

    useEffect(() => {
        if (init) {
            init();
        }
    }, [init]);

    const setColorStyle = (items) => {
        items.forEach((item) => {
            if (item.key === 'is_active') {
                if(item.value === 'Active') {
                    item.color = 'green-style';
                }

                if (item.value === 'Blocked') {
                    item.color = 'red-style';
                }
            }

            if (item.key === 'is_test') {
                if(item.value === 'No') {
                    item.color = 'green-style';
                }

                if (item.value === 'Yes') {
                    item.color = 'red-style';
                }
            }

            if (item.key === 'coefficient_sums_of_bets_and_deposit') {
                if (item.value  < 3) {
                    item.color = 'red-style';
                }
            }

            if (item.key === 'deposits_count') {
                if (item.value === 1) {
                    item.color = 'red-style';
                }
                if (item.value > 1) {
                    item.color = 'green-style';
                }
            }

            if (item.key === 'bets_total_count') {
                if (item.value <= 5) {
                    item.color = 'red-style';
                }
                if (item.value >= 15) {
                    item.color = 'green-style';
                }
            }

            if (item.key === 'bets_cash_count') {
                if (item.value <= 5) {
                    item.color = 'red-style';
                }
                if (item.value >= 15) {
                    item.color = 'green-style';
                }
            }
        });

        return items;
    };

    if(item === null) {
        return (
            <div className="ibox-content">
                <div className="form-horizontal form-horizontal_flex"></div>
            </div>
        );
    }

    const staticNamesIP = t?.conversionItemPage || {};
    const staticNames = t?.conversionUserInfoChart || {};

    let externalInfo = item.userInfo?.external_info || [];
    let internalInfo = item.userInfo?.internal_info || [];

    externalInfo = setColorStyle(externalInfo);
    internalInfo = setColorStyle(internalInfo);

    return (
        <div className="ibox-content field-list-holder">
            <div className="ibox-title">
                <h5>{staticNamesIP.userInfo}</h5>
            </div>
            <div className="form-horizontal form-horizontal_flex">
                <div className={'user-info-columns'}>
                    <div className={'user-info-column'}>
                        <p><i>{staticNames.internalTitle}</i></p>
                        {internalInfo.map((key) => (
                            <FormGroup
                                key={key.key}
                                label={`${key.title}:`}
                                labelClass={''}
                                fieldClass={key.color}
                            >{`${key.value}`}</FormGroup>
                        ))
                        }
                    </div>
                    <div className={'user-info-column'}>
                        <p><i>{staticNames.externalTitle}</i></p>
                        {externalInfo.map((key) => (
                            <FormGroup
                                key={key.key}
                                label={`${key.title}:`}
                                labelClass={''}
                                fieldClass={key.color}
                            >{`${key.value}`}</FormGroup>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

ConversionUserInfoChart.propTypes = {
    item: PropTypes.object,
    loading: PropTypes.bool,
    init: PropTypes.func
};

ConversionUserInfoChart.defaultProps = {
    item: null,
    loading: false,
    init: () => {}
};

export default ConversionUserInfoChart;
